module.exports = __webpack_public_path__ + "img/12955a8.jpg";